import Joi from 'joi';

export const PlanManagePayloadSchema = Joi.object({
  extendedInfo: Joi.string(),
  reason: Joi.string(),
});

export const ChangePaymentMethodSchema = Joi.object({
  address: Joi.string(),
  city: Joi.string(),
  country_code: Joi.string(),
  state_code: Joi.string(),
  zip_code: Joi.string(),
});

export const ChangePaymentMethodPayloadSchema = Joi.object({
  token_id: Joi.string(),
  billing_info: ChangePaymentMethodSchema,
});

export const ChangePaymentMethodResponseSchema = Joi.object({
  customer_id: Joi.string(),
  card_info: Joi.object({
    billing_addr1: Joi.string(),
    billing_city: Joi.string(),
    billing_country: Joi.string(),
    billing_state: Joi.string(),
    billing_state_code: Joi.string(),
    billing_zip: Joi.string(),
    brand: Joi.string(),
    expiry_month: Joi.number(),
    expiry_year: Joi.number(),
    first_name: Joi.string(),
    funding_type: Joi.string(),
    iin: Joi.string(),
    last4: Joi.string(),
    last_name: Joi.string(),
    masked_number: Joi.string(),
    object: Joi.string(),
  }),
  message: Joi.array().items(Joi.string()),
});
